module.exports = __webpack_public_path__ + "img/banner02_h5.93eab460.webp";